/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, OverlayTrigger, Popover, Container } from 'react-bootstrap';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import './coverageHistory.scss';
import { capitalizeFirstLetter, insertSpaces } from '../../../../utils/strings';
import APIEndpoints from '../../../../api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import CoverageHistorySkeleton from './skeleton/CoverageHistorySkeleton';
import useDate from '../../../../utils/useDate';

export const CoverageHistory = (PlanInfo) => {
  const activeCoverageType = PlanInfo?.activeCoverageType;
  const activeMemType = PlanInfo?.activeMemType;
  const activeOID = PlanInfo?.activeOID;
  //const coverageData = PlanInfo?.coverageData;
  const membersCovered = PlanInfo?.membersCovered;
  //const isAPIFailed=PlanInfo?.isAPIFailed;
  //const isNotFound=PlanInfo?.isNotFound;
  const [planDetails, setPlanDetails] = useState([]);
  const [coverageData, setCoverageData] = useState([]);
  const [dataFetching, setDataFetching] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const { formatDate } = useDate();
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;
  const fetchCoverageSummary = async (oid, memType) => {
    try {
      const responseExtCoverage = await axiosInstance.get(
        APIEndpoints.getMemberExtCoverageSummaryResource() +
          memType +
          '/oid/' +
          oid,
      );
      const memberExtCoverageSummary =
        responseExtCoverage?.data.Response.EligibilityCoverage;
      const memberExtCoveragePlanDetails =
        responseExtCoverage?.data.Response.EligibilityCoverage[0];
      const memberExtCoveragedata =
        responseExtCoverage?.data.Response.EligibilityCoverage[0]
          .MemberCoverage;

      setPlanDetails(memberExtCoveragePlanDetails);
      setCoverageData(memberExtCoverageSummary);
      setDataFetching(false);
    } catch (error) {
      console.log(error);
      setDataFetching(false);
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      }
      setIsAPIFailed(true);
    }
  };
  useEffect(() => {
    setDataFetching(true);
    fetchCoverageSummary(activeOID, activeMemType);
  }, [activeOID]);
  const statusHandler = (status, TerminationReason) => {
    if (status === 'Terminated') {
      return (
        <div>
          {status}&nbsp;
          <OverlayTrigger
            placement="top"
            delay={{ show: 300, hide: 450 }}
            overlay={
              <Popover>
                <Popover.Content>
                  <div className="tooltip-header">Termination Reason</div>
                  {TerminationReason}
                </Popover.Content>
              </Popover>
            }
          >
            <span className="InfoSVG">
              <svg
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                className="info-svg-alg"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.619,12.006 L6.38,12.006 C6.167,12.006 5.995,11.805 5.995,11.558 C5.995,11.311 6.167,11.11 6.38,11.11 L7,11 L7,8 L6.38,7.884 C6.167,7.884 5.995,7.683 5.995,7.436 C5.995,7.189 6.167,6.988 6.38,6.988 L8.894,6.988 C8.971,6.988 8.996,6.956 9.007,6.93 C9.004,6.945 9,6.959 9,7 L9,11 L9.619,11.11 C9.832,11.11 10.005,11.311 10.005,11.558 C10.005,11.805 9.832,12.006 9.619,12.006 L9.619,12.006 Z M7,4 L7.98,4 C7.987,4 7.993,3.996 8,3.996 C8.007,3.996 8.013,4 8.02,4 L9,4 L9,4.94 C9.001,4.962 9.012,4.98 9.012,5.001 C9.012,5.023 9.001,5.041 9,5.062 L9,6 L8.033,6 C8.021,6.001 8.011,6.007 8,6.007 C7.988,6.007 7.978,6.001 7.967,6 L7,6 L7,5.061 C6.998,5.04 6.987,5.023 6.987,5.001 C6.987,4.98 6.998,4.962 7,4.941 L7,4 Z M8,0 C3.581,0 0,3.582 0,8 C0,12.418 3.581,16 8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 L8,0 Z"
                  id="path-1"
                ></path>
              </svg>
            </span>
          </OverlayTrigger>
        </div>
      );
    }
    return status;
  };

  return (
    <>
      {isAPIFailed ? (
        <Container className="px-0">
          {isNotFound ? (
            <CustomClientError
              ErrorHeading="No Coverages found!"
              ErrorMessage="The selected Member does not have any Coverages."
            />
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
            />
          )}
        </Container>
      ) : (
        <>
          {dataFetching ? (
            <CoverageHistorySkeleton />
          ) : (
            coverageData &&
            coverageData.map((data, index) => {
              const MemberCoverage = data.MemberCoverage.find(
                (item) => insertSpaces(item.Product) === activeCoverageType,
              );
              if (!MemberCoverage) return;
              return (
                <div key={index} className="coverage-card">
                  <Row>
                    <Col className="coverage-frame">
                      <div>
                        <div className="coverage-content">
                          <span>Coverage Period: </span>
                          <span>
                            {formatDate(data.EffectiveDate)} -{' '}
                            {data.TerminationDate === null ? (
                              <>Current</>
                            ) : (
                              formatDate(data.TerminationDate)
                            )}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {MemberCoverage?.BenefitPlan && (
                    <Row className="coverage-text">
                      <Col xs={6}>
                        <span>Benefit Plan:</span>
                      </Col>
                      <Col xs={6}>
                        <span>{MemberCoverage?.BenefitPlan}</span>
                      </Col>
                    </Row>
                  )}
                  <Row className="coverage-text">
                    <Col xs={6}>
                      <span>Coverage Status:</span>
                    </Col>
                    <Col xs={6}>
                      <span>
                        {statusHandler(data.Status, data.TerminationReason)}
                      </span>
                    </Col>
                  </Row>
                  {activeCoverageType === 'Short Term Disability' ||
                  activeCoverageType === 'Long Term Disability' ? null : (
                    <Row className="coverage-text">
                      <Col xs={6}>
                        <span>Other Insurance:</span>
                      </Col>
                      <Col xs={6}>
                        <span>{MemberCoverage?.OtherInsurance || 'NA'}</span>
                      </Col>
                    </Row>
                  )}
                  {/*{activeMemType === 'Employee' && <Row className="coverage-text">
                  <Col xs={6} >
                    <span>Members Covered:</span>
                  </Col>
                  <Col xs={6} >

                    { activeCoverageType === 'Short Term Disability' || activeCoverageType === 'Long Term Disability'  ?
                      ( <span>Employee Only</span> )
                      : ( membersCovered&&membersCovered.map( ( member, index ) => {
                        if ( index !== 0 ) {
                          return <div className="plan-details-data" key={index}>{member.label}</div>;
                        } else {
                          return null;
                        }
                      } ) )}
                  </Col>
                </Row>} */}
                </div>
              );
            })
          )}
        </>
      )}
    </>
  );
};
